<template>
    <!--横向填空-->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">横向填空</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
                    class="outline-none " 
                    :qid="question.qid" 
                    :class="question.qid"  
                    :value="question.questionsName" 
                    @childValueChange="val=>{ question.questionsName = val }" 
                ></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<template>
					<el-dropdown v-if="!$route.query.bankId" @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
						<span class="el-dropdown-link">
							<el-tooltip content="收藏到题库" placement="top" effect="light">
                <i v-if="question.isedit && !question.bqid"  class="el-icon-star-off to-bank item"></i>
							</el-tooltip>
						</span>
						<el-dropdown-menu slot="dropdown">
							<div class="scroll-body" style="overflow-y: auto;" :style="{maxHeight: isAddBank ? '102px' : '200px'}">
							<el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
								<span>{{item.name}}</span>
								<el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
							</el-dropdown-item>
							<el-dropdown-item 
								disabled
								style="
								font-size: 12px;
								color: #ccc"
								class="dropdown-item" 
								v-if="bankList.length == 0">
								<span>暂无题库</span>
							</el-dropdown-item>
							</div>

							<el-dropdown-item v-if="isAddBank" divided style="text-align:center">
							<el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
								<el-form-item
								prop="name"
								:rules="[
									{ required: true, message: '不能为空'},
								]"
								>
								<el-input size="mini" v-model="bankForm.name"></el-input>
								</el-form-item>
								<el-form-item  size="mini" style="text-align: right;margin-bottom: 0;">
								<el-button type="text" @click="addBank">创建</el-button>
								<el-button  type="text" @click="cancelAddBank">取消</el-button>
								</el-form-item>
							</el-form>
							</el-dropdown-item>
							
							<el-dropdown-item divided style="text-align:center">
							<el-button  @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tooltip content="取消收藏" placement="top" effect="light">
						<i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid"  @click="delFormBank"></i>
					</el-tooltip>
				</template>
				<template v-if="!isBankViewTest">
					<div @click="() => $emit('jumpshow', question)">
						<el-badge 
							v-if="question.logicalSettings.num" 
							:value="question.logicalSettings.num" 
							class="item">
							<i class="el-icon-share"  ></i>
						</el-badge>
					</div>
					<i  class="el-icon-rank item drag-handle"></i>
					<i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyClick(question)"></i>
					<i class="el-icon-delete delete" v-if="question.isedit" @click="questiondel(question.qid)"></i>
				</template>
			</el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;margin-bottom: 12px">
            <div >
                <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                    class="el_item_option item_container_title" style="margin-left:50px">
                    <!-- <el-input v-model="question.quesOptionTitle" placeholder="请输入内容"></el-input> -->
                    <div class=" quesOptionTitle-box">
                        
                        <template>
                            <span v-if="isBankViewTest">{{item.questionsName}}</span>
                            <TitleEditor 
                                v-if="!isBankViewTest" 
                                class="outline-none quesOptionTitle" 
                                :qid="`quesOption${question.qid}`" 
                                :class="`quesOption${question.qid}`"  
                                :value="question.quesOptionTitle" 
                                @childValueChange="childValueChange" 
                            ></TitleEditor>
                        </template>
                        <div class="control" style="display: flex;">
                            <i
                            class="el-icon-s-tools el-icon-common-option"
                            @click.stop="setQuestion"
                            ></i>
                            <el-tooltip 
                                content="每个填空符为2个汉字宽度，可连续输入，其长短决定答题填空宽度，可用键盘删除键回退内容" 
                                placement="top" 
                                effect="light"
                            >
                                <i class="el-icon-question  el-icon-common-option"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </el-col>
            </div>

        </el-row>
    
    <!-- 横向填空题设置 -->
    <el-dialog
      title="填空属性"
      :visible.sync="horizontalDialog"
      width="1000px"
      :before-close="() => {horizontalDialog = false}" :close-on-click-modal="false">
      <span style="line-height: 40px;" v-html="question.quesOptionTitle"></span>
      <el-table
        @selection-change="horizontalChange"
        :data="optionList"
        ref="multipleTable"
        border
        style="width: 100%">
        <el-table-column
          label="填空序号"
          width="180"
          align="center">
          <template #default='scope'>{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column
          label="内容限制"
          align="center">
          <template #default='scope'>
            <el-select
              v-model="scope.row.format"
                :popper-append-to-body="false"
              placeholder="不限"
            >
              <el-option
                v-for="item in formatList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="范围"
          width="300"
          align="center">
          <template #default='scope'>
            <div class="itemC">
              最多填写
              <el-input-number 
                class="range-input"
                v-model.number="scope.row.maxNum"
                controls-position="right"
                :min="1" ></el-input-number>
              字
            </div>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          label="此空必填"
          width="100"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="horizontalDialog = false">取 消</el-button>
        <el-button type="primary" @click="horizontalSubmit">确 定</el-button>
      </span>
    </el-dialog>
    </div>
</template>
<script>
import { v1 as UUID } from "uuid"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
    components:{
        TitleEditor,
    },
        data() {
            return {
                horizontalDialog: false,
                horizontalSetObj: {},
                optionList: [],
                formatList: [
                    {
                    value: 0,
                    label: '不限'
                    },
                    {
                    label: "数字",
                    value: 1,
                    },
                    {
                    label: "字母",
                    value: 2,
                    },
                    {
                    label: "中文",
                    value: 3,
                    },
                    {
                    label: "Email",
                    value: 4,
                    },
                    {
                    label: "手机号",
                    value: 5,
                    },
                ],
                multipleSelection: [],
      
      // 题库start
			isAddBank: false,
			bankForm: {
				isSystemBank: 0, // 我的题库
				name: '',
				type: '未分类',
            	bankType: 1
			}
      // 题库end
            }
        },
        props: {
            question: {},
            index: {type:Number,default:0},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
            bankList: {
                type: Array,
                default: () => {
                return []
                }
            },
        },
        watch: {
            'question.questionsName':{
                handler(newV, oldV){
                    if (newV !== oldV && this.question.bqid) {
                        this.question.bqid = ''
                    }
                },
                deep: true
            },
            'question.quesOptionTitle':{
                handler(newV, oldV){
                    if (newV !== oldV && this.question.bqid) {
                        this.question.bqid = ''
                    }
                },
                deep: true
            },
        },
        methods: {
			copyClick(question){
				this.$emit('questionCopy',question)
			},
            childValueChange(val){
                console.log()
                this.question.quesOptionTitle = val
                this.quesOptionTitleBlur()
            },
            quesOptionTitleBlur() {
                // this.question.quesOptionTitle = this.$refs.quesOptionTitle.innerHTML
                let arr = this.question.quesOptionTitle.match(/_[_]+_/g)
                console.log(arr)
                let num = arr.length - this.question.optionList.length
                if (num > 0){
                    for (let i = 0; i < num; i++){
                        let obj = {
                            oid: UUID(),
                            length: 0,
                            labelName: 0,
                            optionScore: 0,
                            format: 0, // 输入框格式
                            mustanswer: true,
                            maxNum: 500
                        }
                        this.question.optionList.push(obj)
                    }
                    arr.forEach((info, index) => {
                        this.question.optionList[index].length = info.length
                        this.question.optionList[index].labelName = index + 1
                    })
                } else {
                    this.question.optionList.length = arr.length
                }
            },
            // 题库start
            getBankList(e) {
                if (e) {
                    this.$emit('getBankList')
                }
            },
            addToBank(id) {
                this.$refs.bankDropdown.hide()
                this.$emit('addToBank', this.question, id)
                console.log(this.question)
            },
            cancelAddBank() {
                this.isAddBank = false
                this.bankForm.name = ''
            },
            addBank() {
                this.$refs.ValidateForm.validate((valid) => {
                    if (valid) {
                        this.isAddBank = true
                        this.$emit('addBank', this.bankForm, this.question.qid)
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
                // this.$refs.bankDropdown.show()
            },
            delFormBank() {
                this.$emit('delFormBank', this.question)
            },
            // 题库end
            // 设置
            setQuestion() {
                this.optionList = JSON.parse(JSON.stringify(this.question.optionList))
                this.horizontalDialog = true
                this.$nextTick(() => {
                    this.optionList.forEach((info) => {
                        if (info.mustanswer) {
                            this.$refs.multipleTable.toggleRowSelection(info, true)
                        }
                    })
                })
            },
            horizontalChange(val){
                this.multipleSelection = val
            },
            horizontalSubmit() {
                let arr = []
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach((el) => {
                        arr.push(el.oid)
                    })
                }
                this.optionList.forEach(item =>{
                    item.mustanswer = false
                    if(arr.indexOf(item.oid) != -1) {
                        item.mustanswer = true
                    }
                })
                this.question.optionList = JSON.parse(JSON.stringify(this.optionList))
                this.horizontalDialog = false
            },
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            questiondel(id){
                this.$emit("questiondel",id);
            },
        },
        created() {
            // console.log('questionBlank',this.question)
        }
    }
</script>

<style scoped lang="scss">
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        // height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    
.outline-none{
  outline: none;
  width: 100%;
}
.quesOptionTitle-box{
    width: 100%;
    display: flex;
    align-items: flex-start;
    .quesOptionTitle{
        font-size: 14px;
    }
}
/deep/.el-input__inner{
    border: 1px solid #dcdfe6 !important;
}
/deep/.el-table__header .el-table-column--selection .cell .el-checkbox:after {
  content: " 此空必填";
}
</style>
